import { render, staticRenderFns } from "./FeedPlan.vue?vue&type=template&id=13afde76&scoped=true"
import script from "./FeedPlan.vue?vue&type=script&lang=ts"
export * from "./FeedPlan.vue?vue&type=script&lang=ts"
import style0 from "./FeedPlan.vue?vue&type=style&index=0&id=13afde76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13afde76",
  null
  
)

export default component.exports